import React, { useEffect } from 'react';
import { useField } from 'react-final-form';
import { useHistory } from 'react-router';
import { useLocation, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import type { ReactElement } from 'react';

import { RoutePath } from '@components/AppRouter/constants';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';
import { organizationCardStore } from '@stores/dictionaryStores/organizationsStore/organizationCardStore';
import type { CompanyDto } from '@src/api';

import { NEW_ENTITY_ID } from '../../../../AppRouter/hooks/constants';
import { OrganizationCardInfo } from '../OrganizationCardInfo';
import { OrganizationCardFormField } from '../types';

export function OrganizationCardPageComponent({ counterparties }: { counterparties: CompanyDto[] }): ReactElement {
  const { state: routeState } = useLocation();
  const { code } = useParams<{ code: string }>();
  const { organizations } = organizationsStore;
  const { isNew, editMode } = organizationCardStore;
  const { push } = useHistory();

  const {
    input: { onChange: onChangeParentCode },
  } = useField(OrganizationCardFormField.PARENT_CODE);

  useEffect(() => {
    if (code !== NEW_ENTITY_ID) {
      return;
    }

    if (!routeState) {
      push(RoutePath.ORGANIZATIONS);
      return;
    }

    const { organizationCode, child } = routeState;

    if (child) {
      onChangeParentCode(organizationCode);
      return;
    }

    const organization = organizations.find((item) => item.code === organizationCode);

    if (organization) {
      onChangeParentCode(organization.parentCode);
    }
  }, [organizations, routeState, onChangeParentCode, code, push, isNew]);

  return <OrganizationCardInfo readOnly={!editMode} counterparties={counterparties} />;
}

export const OrganizationCardPage = observer(OrganizationCardPageComponent);
